import { reactive, watch, onMounted, computed } from '@vue/composition-api'
import useRouter from '../useRouter'
import useStore from '../useStore'

const initialMenuList = [
    {
        type: 'link',
        title: 'Dashboard',
        active: true,
        routeName: 'requests',
        icon: 'dashboard-menu-icon',
        activeChild: '',
        showChildren: true,
        id: 'dashboard-sidebar',
        children: [
            {
                name: 'Crossprom Requests',
                routeName: 'requests',
                icon: 'cpreq-icon-sidebar',
                id: 'cp-requests-sidebar'
            },
            {
                name: "Campaigns' Updates",
                routeName: 'updates',
                icon: 'updates-icon-sidebar',
                id: 'campaigns-updates-dashboard'
            },
        ]
    },
    {
        type: 'tab',
        title: 'My Campaigns',
        active: false,
        routeName: 'campaigns',
        activeChild: 'publish',
        icon: 'dashboard-menu-camp-icon',
        showChildren: true,
        id: 'my-campaigns-dashboard',
        children: [
            {
                name: 'Published',
                routeName: 'publish',
                icon: 'published-icon-sidebar',
                id: 'published-dashboard-sidebar'
            },
            {
                name: 'Drafts',
                routeName: 'drafts',
                icon: 'draft-icon-sidebar',
                id: 'drafts-dashboard-sidebar'
            },
            {
                name: 'Archive',
                routeName: 'archives',
                icon: 'archived-icon-sidebar',
                id: 'archive-dashboard-sidebar'
            },
            {
                name: 'My Favorites',
                routeName: 'favorite',
                icon: 'favorited-icon-sidebar',
                id: 'my-favorites-dashboard-sidebar'
            },
        ]
    },
    {
        type: 'link',
        title: 'My Membership',
        active: false,
        hidden: false,
        routeName: 'membership',
        icon: 'crown',
        activeChild: null,
        children: []
    },

]


const useMenu = (emptyCampaigns) => {
    const { route, router } = useRouter()
    const { store } = useStore()
    const currentRoute = {...route.value} 
    const menuList = reactive([...initialMenuList])

    menuList[0].showChildren = !emptyCampaigns

    const haspremiumPlan = computed(() => store.state.user.premiumPlan)
    const isInternalUser = computed(() => store.state.user.isAdmin)
    
    menuList[2].hidden = isInternalUser
    
    watch(isInternalUser, (isInternalUser) => {
        menuList[2].hidden = isInternalUser
    },{immediate: true})

    
    onMounted(() => {
        if(currentRoute.name === 'dashboard') {
            router.push({
                name: 'requests'
            }).catch(() => {})
        }
        if(currentRoute.name === 'campaigns') {
            menuList.forEach(item => {
                item.active = false
            })
            if(menuList[1]) {
                menuList[1].active = true
            }
        }
    })

    const activeSubMenu = (payload) => {
        menuList.forEach(item => {
            item.active = false
            if(!item.children.length && item.routeName === payload.name) {
                item.active = true
                item.activeChild = payload.name
            }
            if(item.children && item.children.find(el => el.routeName === payload.name)) {
                item.active = true
                item.activeChild = payload.name
            }
            if(item.children && item.children.find(el => el.routeName === payload.params.campaignType)) {
                item.active = true
                item.activeChild = payload.params.campaignType
            }
        })
    }
    watch([route], ([route]) => {
        activeSubMenu(route)
    },{immediate: true})

    return {
        menuList,
    }
}

export default useMenu